import React, { useEffect, useRef } from 'react';
import { createChart, ColorType, CandlestickSeries } from 'lightweight-charts';

const CandlestickChart = ({
  data = [],
  colors = {
    backgroundColor: '#000000',
    textColor: '#FFFFFF',
    upColor: '#26a69a',
    downColor: '#ef5350',
    borderUpColor: '#26a69a',
    borderDownColor: '#ef5350',
    wickUpColor: '#26a69a',
    wickDownColor: '#ef5350',
  },
}) => {
  const containerRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    // If a chart already exists, remove it
    if (chartRef.current) {
      chartRef.current.chart.remove();
    }

    // Create a new chart instance
    const chart = createChart(containerRef.current, {
      width: containerRef.current.clientWidth,
      height: 300,
      layout: {
        background: { type: ColorType.Solid, color: colors.backgroundColor },
        textColor: colors.textColor,
      },
      grid: {
        vertLines: { color: 'rgba(197, 203, 206, 0.5)' },
        horzLines: { color: 'rgba(197, 203, 206, 0.5)' },
      },
      rightPriceScale: {
        borderColor: 'rgba(197, 203, 206, 0.8)',
      },
      timeScale: {
        borderColor: 'rgba(197, 203, 206, 0.8)',
      },
    });

    chart.timeScale().fitContent();

    // Use the new addSeries() API by passing the series constructor
    const candlestickSeries = chart.addSeries(CandlestickSeries, {
      upColor: colors.upColor,
      downColor: colors.downColor,
      borderUpColor: colors.borderUpColor,
      borderDownColor: colors.borderDownColor,
      wickUpColor: colors.wickUpColor,
      wickDownColor: colors.wickDownColor,
    });

    // Set data on the series
    candlestickSeries.setData(data);

    // Store chart and series references
    chartRef.current = { chart, candlestickSeries };

    // Handle responsiveness
    const handleResize = () => {
      chart.applyOptions({ width: containerRef.current.clientWidth });
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      chart.remove();
      chartRef.current = null;
    };
  }, [data, colors]);

  return <div ref={containerRef} style={{ width: '100%', height: '300px' }} />;
};

export default CandlestickChart;




// import React, { useEffect, useRef } from 'react';
// import { createChart, ColorType, CandlestickSeries } from 'lightweight-charts';

// const CandlestickChart = ({
//   data = [],
//   colors = {
//     backgroundColor: '#000000',
//     textColor: '#FFFFFF',
//     upColor: '#26a69a',
//     downColor: '#ef5350',
//     borderUpColor: '#26a69a',
//     borderDownColor: '#ef5350',
//     wickUpColor: '#26a69a',
//     wickDownColor: '#ef5350',
//   },
// }) => {
//   const chartContainerRef = useRef(null);
//   const chartInstanceRef = useRef(null);

//   useEffect(() => {
//     if (!chartContainerRef.current) return;

//     // Clean up any previous chart instance
//     if (chartInstanceRef.current) {
//       try {
//         chartInstanceRef.current.remove();
//       } catch (e) {
//         console.error("Error removing previous chart instance:", e);
//       }
//     }

//     const containerWidth = chartContainerRef.current.clientWidth || 600;

//     // Create a new chart instance
//     const chart = createChart(chartContainerRef.current, {
//       width: containerWidth,
//       height: 300,
//       layout: {
//         background: { type: ColorType.Solid, color: colors.backgroundColor },
//         textColor: colors.textColor,
//       },
//       grid: {
//         vertLines: { color: "rgba(197, 203, 206, 0.5)" },
//         horzLines: { color: "rgba(197, 203, 206, 0.5)" },
//       },
//       rightPriceScale: {
//         borderColor: "rgba(197, 203, 206, 0.8)",
//       },
//       timeScale: {
//         borderColor: "rgba(197, 203, 206, 0.8)",
//       },
//     });

//     chart.timeScale().fitContent();

//     // Add the candlestick series using the new addSeries() API
//     const candlestickSeries = chart.addSeries(CandlestickSeries, {
//       upColor: colors.upColor,
//       downColor: colors.downColor,
//       borderUpColor: colors.borderUpColor,
//       borderDownColor: colors.borderDownColor,
//       wickUpColor: colors.wickUpColor,
//       wickDownColor: colors.wickDownColor,
//     });

//     // Set the chart data
//     candlestickSeries.setData(data);

//     // Handle responsiveness
//     const handleResize = () => {
//       const width = chartContainerRef.current.clientWidth || 600;
//       chart.applyOptions({ width });
//     };

//     window.addEventListener('resize', handleResize);
//     chartInstanceRef.current = chart;

//     // Cleanup function: remove the resize listener and dispose the chart
//     return () => {
//       window.removeEventListener('resize', handleResize);
//       if (chartInstanceRef.current) {
//         try {
//           chartInstanceRef.current.remove();
//         } catch (e) {
//           console.error("Error during chart removal in cleanup:", e);
//         }
//         chartInstanceRef.current = null;
//       }
//     };
//   }, [data, colors]);

//   return <div ref={chartContainerRef} style={{ width: '100%', height: '300px' }} />;
// };

// export default CandlestickChart;
